module.exports = __webpack_public_path__ + "static/media/CTLI_12-147w.0c132c14.jpg";